// src/components/Sidebar/ComponentLibrary/IconPackSelector.tsx
import React from 'react';

export interface IconPack {
  id: string;
  name: string;
  count: number;
}

interface IconPackSelectorProps {
  packs: IconPack[];
  selectedPack: string;
  onSelectPack: (packId: string) => void;
}

export const IconPackSelector: React.FC<IconPackSelectorProps> = ({
  packs,
  selectedPack,
  onSelectPack
}) => {
  return (
    <div>
      <div className="flex flex-wrap gap-2 p-4">
        {packs.map((pack) => (
          <button
            key={pack.id}
            onClick={() => onSelectPack(pack.id)}
            className={`rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${
              selectedPack === pack.id
                ? 'bg-blue-500 text-white shadow-sm'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-slate-700 dark:text-gray-300 dark:hover:bg-slate-600'
            }`}
          >
            {pack.name} ({pack.count})
          </button>
        ))}
      </div>
    </div>
  );
};
